export default "__VITE_ASSET__CDD8DO8w__"